import { createRouter, createWebHistory } from "vue-router";
import { useMaintenanceStore, usePausedTimepointStore } from "@/stores";

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/LoginView.vue"),
    },
    {
      path: "/logout",
      name: "logout",
      component: () => import("@/views/LogoutView.vue"),
    },
    {
      path: "/loggedout",
      name: "loggedOut",
      component: () => import("@/views/LoggedOutView.vue"),
    },
    {
      path: "/page-not-found",
      name: "page-not-found",
      component: () => import("@/views/PageNotFoundView.vue"),
    },
    {
      path: "/t/:token",
      name: "tokenLogin",
      redirect: (to) => ({
        name: "app",
        params: { token: to.params.token },
        query: to.query,
        hash: to.hash,
      }),
    },
    {
      // Note: AuthenticatedAppView.vue is a wrapper that has its own custom router (i.e. navStore)
      path: "/:token",
      name: "app",
      component: () => import("../views/ParticipantEntryView.vue"),
    },
    { path: "/:pathMatch(.*)*", redirect: "/page-not-found" },
  ],
});

// App.vue hides RouterView while the maintenance/paused screens are active,
// so the views can't clear that state themselves on logout or token switch.
// afterEach (not beforeEach), so RouterView only re-shows once the
// destination is current, rather than remounting the outgoing view.
router.afterEach((to, from) => {
  const isLeavingToLogout = to.name === "logout" || to.name === "loggedOut";
  const isSwitchingParticipant =
    to.name === "app" && to.params.token !== from.params.token;

  if (isLeavingToLogout || isSwitchingParticipant) {
    useMaintenanceStore().reset();
    usePausedTimepointStore().reset();
  }
});
